// extracted by mini-css-extract-plugin
export default {"infoBanner":"InfoBanner_infoBanner__0ZG7x","icon":"InfoBanner_icon__6qRAD","iconClose":"InfoBanner_iconClose__FsxW2","description":"InfoBanner_description__scz8f"};